import { n as get, t as save } from "./save.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/external/ui-state/hooks/useGet.ts
const getQueryKey = ({ path }) => [{
	url: "/api/mdm/external/api/external/ui-state/:key",
	params: path
}];
function getQueryOptions({ path }, config = {}) {
	const queryKey = getQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await get({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Возвращает сохранённое значение либо значение по умолчанию из whitelist.
* @summary Получить состояние UI по ключу
* {@link /api/mdm/external/api/external/ui-state/:key}
*/
function useGet({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/external/ui-state/hooks/useSave.ts
const saveMutationKey = () => [{ url: "/api/mdm/external/api/external/ui-state/:key" }];
function saveMutationOptions(config = {}) {
	const mutationKey = saveMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await save({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Upsert произвольного JSON-значения для (пользователь, ключ).
* @summary Сохранить состояние UI по ключу
* {@link /api/mdm/external/api/external/ui-state/:key}
*/
function useSave(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? saveMutationKey();
	const baseOptions = saveMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { getQueryOptions as a, getQueryKey as i, saveMutationOptions as n, useGet as o, useSave as r, saveMutationKey as t };

//# sourceMappingURL=useSave.js.map